import { render } from "./PropertiesPage.vue?vue&type=template&id=2ce52f8e&scoped=true"
import script from "./PropertiesPage.vue?vue&type=script&lang=js"
export * from "./PropertiesPage.vue?vue&type=script&lang=js"

import "./PropertiesPage.vue?vue&type=style&index=0&id=2ce52f8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce52f8e"]])

export default __exports__